import React from "react";

interface CardGradientProps {
  className?: string;
  width?: string | number;
  height?: string | number;
}

const SearchIcon: React.FC<CardGradientProps> = ({
  className,
  width = "24",
  height = "24",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_2060_16195"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_2060_16195)">
        <path
          d="M11.25 13.5C11.8833 13.5 12.4167 13.2833 12.85 12.85C13.2833 12.4167 13.5 11.8833 13.5 11.25C13.5 10.6167 13.2833 10.0833 12.85 9.65C12.4167 9.21667 11.8833 9 11.25 9C10.6167 9 10.0833 9.21667 9.65 9.65C9.21667 10.0833 9 10.6167 9 11.25C9 11.8833 9.21667 12.4167 9.65 12.85C10.0833 13.2833 10.6167 13.5 11.25 13.5ZM11.25 15.5C10.0667 15.5 9.0625 15.0875 8.2375 14.2625C7.4125 13.4375 7 12.4333 7 11.25C7 10.0667 7.4125 9.0625 8.2375 8.2375C9.0625 7.4125 10.0667 7 11.25 7C12.4333 7 13.4375 7.4125 14.2625 8.2375C15.0875 9.0625 15.5 10.0667 15.5 11.25C15.5 11.6333 15.4458 12.0125 15.3375 12.3875C15.2292 12.7625 15.0667 13.1167 14.85 13.45L16.8 15.4C17 15.6 17.0958 15.8333 17.0875 16.1C17.0792 16.3667 16.975 16.6 16.775 16.8C16.575 16.9833 16.3417 17.0792 16.075 17.0875C15.8083 17.0958 15.575 17 15.375 16.8L13.45 14.875C13.1167 15.0917 12.7625 15.25 12.3875 15.35C12.0125 15.45 11.6333 15.5 11.25 15.5ZM5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V16C3 15.7167 3.09583 15.4792 3.2875 15.2875C3.47917 15.0958 3.71667 15 4 15C4.28333 15 4.52083 15.0958 4.7125 15.2875C4.90417 15.4792 5 15.7167 5 16V19H8C8.28333 19 8.52083 19.0958 8.7125 19.2875C8.90417 19.4792 9 19.7167 9 20C9 20.2833 8.90417 20.5208 8.7125 20.7125C8.52083 20.9042 8.28333 21 8 21H5ZM19 21H16C15.7167 21 15.4792 20.9042 15.2875 20.7125C15.0958 20.5208 15 20.2833 15 20C15 19.7167 15.0958 19.4792 15.2875 19.2875C15.4792 19.0958 15.7167 19 16 19H19V16C19 15.7167 19.0958 15.4792 19.2875 15.2875C19.4792 15.0958 19.7167 15 20 15C20.2833 15 20.5208 15.0958 20.7125 15.2875C20.9042 15.4792 21 15.7167 21 16V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21ZM3 8V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H8C8.28333 3 8.52083 3.09583 8.7125 3.2875C8.90417 3.47917 9 3.71667 9 4C9 4.28333 8.90417 4.52083 8.7125 4.7125C8.52083 4.90417 8.28333 5 8 5H5V8C5 8.28333 4.90417 8.52083 4.7125 8.7125C4.52083 8.90417 4.28333 9 4 9C3.71667 9 3.47917 8.90417 3.2875 8.7125C3.09583 8.52083 3 8.28333 3 8ZM19 8V5H16C15.7167 5 15.4792 4.90417 15.2875 4.7125C15.0958 4.52083 15 4.28333 15 4C15 3.71667 15.0958 3.47917 15.2875 3.2875C15.4792 3.09583 15.7167 3 16 3H19C19.55 3 20.0208 3.19583 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5V8C21 8.28333 20.9042 8.52083 20.7125 8.7125C20.5208 8.90417 20.2833 9 20 9C19.7167 9 19.4792 8.90417 19.2875 8.7125C19.0958 8.52083 19 8.28333 19 8Z"
          fill="black"
        />
      </g>
    </svg>
  );
};

export default SearchIcon;
